import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'

function val(value, min, max) {
  value = parseInt(value)

  if (isNaN(value)) return min

  if (value < min) return min

  if (value > max) return max

  return value
}

export default function RangeInput(props) {
  let { value = false, name, id, onChange, disabled, min = 1, max = 10 } = props

  if (!List.isList(value)) value = List.of(min, max)

  let minValue = parseInt(value.get(0))
  let maxValue = parseInt(value.get(1))

  return (
    <div className="form-field-range">
      <input
        type="number"
        name={`${name}-min`}
        value={minValue}
        onChange={e => onChange({ name, value: value.set(0, val(e.target.value, min, maxValue)) })}
      />
      <span className="form-field-range-middle">-</span>
      <input
        type="number"
        name={`${name}-max`}
        value={maxValue}
        onChange={e => onChange({ name, value: value.set(1, val(e.target.value, minValue, max)) })}
      />
    </div>
  )
}
